/* AskMeMart homepage interactions — no dependencies */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero slider ---------- */
  function initSlider(root) {
    if (root.dataset.ammReady) return;
    root.dataset.ammReady = '1';
    var slides = root.querySelectorAll('.amm-slide');
    var dots = root.querySelectorAll('[data-amm-dot]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden',k!==i); s.inert=k!==i; });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function start() { if (delay && !reduceMotion) { stop(); timer = setInterval(function () { go(i + 1); }, delay); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    var prev = root.querySelector('[data-amm-slide-prev]');
    var next = root.querySelector('[data-amm-slide-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.ammDot); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function(e){if(!root.contains(e.relatedTarget))start();});
    root.addEventListener('mouseleave', start);

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); start(); }
      x0 = null;
    });
    go(0); start();
  }

  /* ---------- Horizontal product rows ---------- */
  function initScrollerWrap(wrap) {
    if (wrap.dataset.ammReady) return;
    wrap.dataset.ammReady = '1';
    function active() {
      return wrap.querySelector('[data-amm-scroller].is-active') || wrap.querySelector('[data-amm-scroller]');
    }
    function step(dir) {
      var s = active(); if (!s) return;
      s.scrollBy({ left: dir * s.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    var p = wrap.querySelector('[data-amm-prev]'), n = wrap.querySelector('[data-amm-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    if (root.dataset.ammTabsReady) return;
    root.dataset.ammTabsReady = '1';
    var tabs = root.querySelectorAll('[data-amm-tab]');
    var panels = root.querySelectorAll('[data-amm-panel]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var k = t.dataset.ammTab;
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
        panels.forEach(function (p) { var on = p.dataset.ammPanel === k; p.classList.toggle('is-active', on); p.hidden = !on; });
      });
    });
  }

  /* ---------- Ajax add to cart ---------- */
  function toast(msg, isError) {
    var t = document.querySelector('.amm-toast');
    if (!t) { t = document.createElement('div'); t.className = 'amm-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.toggle('is-error', !!isError);
    t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.CartCount, .cart-count, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('amm-atc-form')) return;
    e.preventDefault();
    var btn = f.querySelector('button');
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        btn.textContent = 'Added';
        refreshCount();
        if (window.AMM && window.AMM.openCart && document.getElementById('AmmCartDrawer')) { window.AMM.openCart(); } else { toast('Added to cart'); }
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500);
      })
      .catch(function (err) {
        toast((err && err.description) || 'Could not add this item. Please try again.', true);
        btn.textContent = label; btn.disabled = false;
      });
  });


  /* ---------- Collection filters: auto-submit + mobile drawer ---------- */
  function ammFilterSubmit(form) {
    if (!form || form._ammSubmitting) return;
    form._ammSubmitting = true;
    /* drop empty price boxes so the URL stays clean */
    form.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value === '') i.disabled = true; });
    var sec = document.querySelector('.amm-plp'); if (sec) sec.classList.add('is-loading');
    form.submit();
  }
  function ammAutoSubmit(el) {
    if (!el || !el.matches || !el.matches('[data-amm-autosubmit]')) return;
    var panel = document.getElementById('AmmFilterPanel');
    var drawerOpen = panel && panel.classList.contains('is-open');
    var form = el.form || document.getElementById(el.getAttribute('form') || 'AmmFilters');
    if (el.tagName === 'SELECT' || !drawerOpen) ammFilterSubmit(form);
  }
  document.addEventListener('change', function (e) { ammAutoSubmit(e.target); });
  /* old theme plugins (Select2 etc.) fire jQuery-only change events */
  function ammJqHook() {
    if (window.jQuery && !window._ammJq) { window._ammJq = true; window.jQuery(document).on('change', '[data-amm-autosubmit]', function () { ammAutoSubmit(this); }); }
  }
  ammJqHook(); window.addEventListener('load', ammJqHook);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.id !== 'AmmFilters') return;
    f.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value === '') i.disabled = true; });
    var sec = document.querySelector('.amm-plp'); if (sec) sec.classList.add('is-loading');
  });
  function filterDrawer(open) {
    var p = document.getElementById('AmmFilterPanel'); if (!p) return;
    p.classList.toggle('is-open', open);
    document.querySelectorAll('.amm-filters__backdrop').forEach(function (b) { b.classList.toggle('is-open', open); });
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-amm-filter-open]')) filterDrawer(true);
    if (e.target.closest('[data-amm-filter-close]')) filterDrawer(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') filterDrawer(false); });


  /* ---------- Product page ---------- */
  function money(cents) {
    var f = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: f, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return '₹' + (cents / 100).toFixed(2); }
  }
  function initPDP(root) {
    if (root.dataset.ammReady) return; root.dataset.ammReady = '1';
    var jsonEl = root.querySelector('[data-amm-product-json]'); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('#AmmProductForm') || root.querySelector('.amm-pdp__info form');
    var idInput = root.querySelector('[data-amm-variant-id]');
    var qtyInput = root.querySelector('[data-amm-qty-input]');
    var err = root.querySelector('[data-amm-error]');
    var track = root.querySelector('[data-amm-track]');
    var thumbs = root.querySelectorAll('[data-amm-thumb]');
    var dots = root.querySelectorAll('.amm-gallery__dots span');
    var current = product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];

    function goSlide(i) {
      if (!track) return;
      var slide = track.children[i]; if (!slide) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', String(k === i)); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goSlide(+t.dataset.ammThumb); }); });
    root.querySelectorAll('[data-amm-gallery-step]').forEach(function(b){b.addEventListener('click',function(){if(!track)return;var index=[].findIndex.call(thumbs,function(t){return t.classList.contains('is-active');});goSlide((Math.max(0,index)+Number(b.dataset.ammGalleryStep)+track.children.length)%track.children.length);});});
    if (track) track.addEventListener('scroll', function () {
      clearTimeout(track._t); track._t = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
    }, { passive: true });

    function setAll(sel, fn) { root.querySelectorAll(sel).forEach(fn); }
    function update(v) {
      current = v;
      var avail = v && v.available;
      idInput.value = v ? v.id : '';
      root.querySelectorAll('[data-amm-stock-help]').forEach(function(e){e.hidden=!!avail;});
      setAll('[data-amm-price]', function (e) { e.textContent = v ? money(v.price) : '—'; });
      var hasCmp = v && v.compare_at_price > v.price;
      var off = hasCmp ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      setAll('[data-amm-compare]', function (e) { e.hidden = !hasCmp; if (hasCmp) e.textContent = (e.closest('.amm-pdp__price') ? 'MRP ' : '') + money(v.compare_at_price); });
      setAll('[data-amm-off]', function (e) { e.hidden = !hasCmp; e.textContent = off + '% OFF'; });
      setAll('[data-amm-discount]', function (e) { e.hidden = !hasCmp; e.textContent = '-' + off + '%'; });
      setAll('[data-amm-save]', function (e) { e.hidden = !hasCmp; if (hasCmp) e.textContent = 'You save ' + money(v.compare_at_price - v.price); });
      setAll('[data-amm-sku]', function (e) { e.hidden = !(v && v.sku); if (v && v.sku) e.querySelector('b').textContent = v.sku; });
      setAll('[data-amm-sticky-atc]', function(b){b.textContent=!v?'Unavailable':(avail?'Add to cart':'Sold out');});
      setAll('[data-amm-atc], [data-amm-sticky-atc], [data-amm-buynow]', function (b) { b.disabled = !avail; });
      var lbl = root.querySelector('[data-amm-atc-label]'); if (lbl) lbl.textContent = !v ? 'Unavailable' : (avail ? 'Add to cart' : 'Sold out');
      if (v && v.featured_media && track) {
        var idx = [].findIndex.call(track.children, function (c) { return c.dataset.mediaId == v.featured_media.id; });
        if (idx > -1) goSlide(idx);
      }
      if (v && window.history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    root.querySelectorAll('[data-amm-opt]').forEach(function (r) {
      r.addEventListener('change', function () {
        var sel = [];
        root.querySelectorAll('.amm-opt').forEach(function (fs, i) {
          var c = fs.querySelector('input:checked'); sel[i] = c ? c.value : null;
          var l = root.querySelector('[data-amm-opt-label="' + i + '"]'); if (l && c) l.textContent = c.value;
        });
        update(product.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }));
      });
    });
    root.querySelectorAll('[data-amm-qty]').forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.ammQty, 10)); });
    });

    function add() {
      err.hidden = true;
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +idInput.value, quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1) }] }) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
    }
    function fail(e) { err.textContent = (e && (e.description || e.message)) || 'Could not add to cart. Please try again.'; err.hidden = false; }
    function addToCart(btn) {
      if (!current || !current.available) return;
      var old = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
      add().then(function () {
        btn.textContent = 'Added ✓'; refreshCount();
if (window.AMM && window.AMM.openCart && document.getElementById('AmmCartDrawer')) { window.AMM.openCart(); } else { toast('Added to cart'); }
      }).catch(fail).then(function () { setTimeout(function () { btn.innerHTML = old; btn.disabled = !(current && current.available); }, 1400); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(root.querySelector('[data-amm-atc]')); });
    var sticky = root.querySelector('[data-amm-sticky-atc]');
    if (sticky) sticky.addEventListener('click', function () { addToCart(sticky); });
    var buy = root.querySelector('[data-amm-buynow]');
    if (buy) buy.addEventListener('click', function () {
      buy.disabled = true; buy.textContent = 'Going to checkout…';
      add().then(function () { window.location.href = '/checkout'; }).catch(function (e) { fail(e); buy.disabled = false; buy.textContent = 'Buy now'; });
    });

    var bar = root.querySelector('[data-amm-sticky]'); var atc = root.querySelector('[data-amm-atc]');
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(atc);
    }
  }

  function initRelated(el) {
    if (el.dataset.ammLoaded || !el.dataset.url) return; el.dataset.ammLoaded = '1';
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-amm-related]');
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; delete el.dataset.ammReady; initScrollerWrap(el); }
    }).catch(function () {});
  }


  /* ---------- Cart page: quantity steppers auto-update ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-amm-cart-step]'); if (!b) return;
    var inp = b.parentNode.querySelector('[data-amm-cart-qty]');
    inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(b.dataset.ammCartStep, 10));
    scheduleCart(inp.form);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-amm-cart-qty]')) scheduleCart(e.target.form);
  });
  var cartTimer;
  function scheduleCart(form) {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      var sec = form.closest('.amm-cart'); if (sec) sec.classList.add('is-updating');
      var fd = new FormData(form); fd.delete('checkout');
      fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function () { location.reload(); })
        .catch(function () { form.submit(); });
    }, 500);
  }


  /* =========================================================
     DRAWERS (cart + wishlist), ACCOUNT DROPDOWN, LIVE SEARCH
     ========================================================= */
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function img(src, w) { if (!src) return ''; return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2'); }
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    closeDrawers(true);
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    var bd = document.querySelector('.amm-drawer-backdrop'); if (bd) { bd.hidden = false; requestAnimationFrame(function () { bd.classList.add('is-on'); }); }
    document.documentElement.classList.add('amm-lock');
    var x = d.querySelector('.amm-drawer__x'); if (x) setTimeout(function () { x.focus(); }, 50);
  }
  function closeDrawers(silent) {
    document.querySelectorAll('.amm-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    var bd = document.querySelector('.amm-drawer-backdrop'); if (bd) { bd.classList.remove('is-on'); bd.hidden = true; }
    document.documentElement.classList.remove('amm-lock');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart drawer ---------- */
  function renderCart(c) {
    var d = document.getElementById('AmmCartDrawer'); if (!d) return;
    var body = d.querySelector('[data-amm-dc-body]'), foot = d.querySelector('[data-amm-dc-foot]'), ship = d.querySelector('[data-amm-dc-ship]');
    d.querySelector('[data-amm-dc-count]').textContent = c.item_count ? '(' + c.item_count + ')' : '';
    document.querySelectorAll('.CartCount, .amm-cart-count, .amm-bottomnav__n').forEach(function (el) { el.textContent = c.item_count; });
    document.querySelectorAll('.amm-cart-total').forEach(function (el) { el.textContent = money(c.total_price); });
    var th = parseInt(d.dataset.freeShip || '0', 10) * 100;
    if (th && c.item_count) {
      var left = th - c.total_price, pct = Math.min(100, Math.round(c.total_price * 100 / th));
      ship.innerHTML = (left > 0 ? 'Add <b>' + money(left) + '</b> more for <b>FREE shipping</b>' : '🎉 You\'ve unlocked <b>FREE shipping</b>') + '<span class="amm-ship__bar"><span style="width:' + pct + '%"></span></span>';
      ship.hidden = false;
    } else if (c.item_count) { ship.innerHTML = '🚚 <b>FREE shipping</b> across India on this order'; ship.hidden = false; } else { ship.hidden = true; }
    if (!c.item_count) {
      body.innerHTML = '<div class="amm-drawer__empty"><svg viewBox="0 0 24 24" width="52" height="52" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6h15l-2 9H8L6 3H3"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/></svg><p><strong>Your cart is empty</strong></p><a href="/collections/all" class="amm-btn amm-btn--red">Continue shopping</a></div>';
      foot.hidden = true; return;
    }
    body.innerHTML = '<ul class="amm-dc-items">' + c.items.map(function (it, i) {
      var was = it.original_price > it.final_price ? '' : '';
      var variant = it.product_has_only_default_variant ? '' : '<p class="amm-dc-var">' + esc(it.variant_title) + '</p>';
      return '<li class="amm-dc-item" data-line="' + (i + 1) + '">' +
        '<a href="' + it.url + '" class="amm-dc-img">' + (it.image ? '<img src="' + img(it.image, 160) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="amm-dc-info"><a href="' + it.url + '" class="amm-dc-title">' + esc(it.product_title) + '</a>' + variant +
        '<div class="amm-dc-row"><div class="amm-qty amm-qty--sm"><button type="button" class="amm-qty__btn" data-amm-dc-step="-1" aria-label="Decrease">−</button><input type="number" min="0" value="' + it.quantity + '" aria-label="Quantity" data-amm-dc-qty><button type="button" class="amm-qty__btn" data-amm-dc-step="1" aria-label="Increase">+</button></div>' +
        '<b class="amm-dc-price">' + money(it.final_line_price) + '</b></div>' +
        '<button type="button" class="amm-dc-remove" data-amm-dc-remove>Remove</button></div></li>';
    }).join('') + '</ul>';
    d.querySelector('[data-amm-dc-total]').textContent = money(c.total_price);
    foot.hidden = false;
  }
  function loadCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }); }
  function changeLine(line, qty) {
    var d = document.getElementById('AmmCartDrawer'); if (d) d.classList.add('is-busy');
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); }).then(renderCart).catch(function () { toast('Could not update cart', true); })
      .then(function () { if (d) d.classList.remove('is-busy'); });
  }
  function openCart() { openDrawer('AmmCartDrawer'); loadCart().catch(function () { var body = document.querySelector('[data-amm-dc-body]'); if (body) body.innerHTML = '<p role="alert">Could not load your cart. Please refresh or <a href="/cart">view your cart</a>.</p>'; }); }
  window.AMM = window.AMM || {}; window.AMM.openCart = openCart;
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-amm-cart-open]');
    if (o && document.getElementById('AmmCartDrawer') && !document.body.classList.contains('template-cart')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-amm-drawer-close]')) { e.preventDefault(); closeDrawers(); return; }
    var st = e.target.closest('[data-amm-dc-step]');
    if (st) { var li = st.closest('[data-line]'), inp = li.querySelector('[data-amm-dc-qty]'); changeLine(+li.dataset.line, Math.max(0, (+inp.value || 0) + (+st.dataset.ammDcStep))); return; }
    var rm = e.target.closest('[data-amm-dc-remove]');
    if (rm) { changeLine(+rm.closest('[data-line]').dataset.line, 0); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-amm-dc-qty]')) changeLine(+e.target.closest('[data-line]').dataset.line, Math.max(0, +e.target.value || 0));
  });

  /* ---------- Wishlist (saved in this browser) ---------- */
  var WL_KEY = 'amm_wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; } }
  function wlSet(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} wlSync(); }
  function wlSync() {
    var a = wlGet();
    document.querySelectorAll('.dt-wishlist-cnt').forEach(function (el) { el.textContent = a.length; });
    document.querySelectorAll('.amm-wl-count').forEach(function (el) { el.textContent = a.length; el.hidden = !a.length; });
    document.querySelectorAll('[data-amm-wish]').forEach(function (b) { var on = a.indexOf(b.dataset.ammWish) > -1; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    var c = document.querySelector('[data-amm-wl-count]'); if (c) c.textContent = a.length ? '(' + a.length + ')' : '';
  }
  function wlRender() {
    var body = document.querySelector('[data-amm-wl-body]'); if (!body) return;
    function draw(html) { body.innerHTML = html; var page = document.querySelector('[data-amm-wl-page]'); if (page) page.innerHTML = html; }
    var a = wlGet();
    if (!a.length) { draw('<div class="amm-drawer__empty"><svg viewBox="0 0 24 24" width="52" height="52" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg><p><strong>No saved items yet</strong></p><p>Tap the ♡ on any product to save it here.</p><a href="/collections/all" class="amm-btn amm-btn--red">Browse products</a></div>'); return; }
    draw('<p class="amm-drawer__loading">Loading…</p>');
    Promise.all(a.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        ps = ps.filter(Boolean);
        draw('<ul class="amm-dc-items">' + ps.map(function (p) {
          var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
          var single = p.variants.length === 1;
          var btn = !v.available ? '<button type="button" class="amm-btn amm-btn--outline" disabled>Sold out</button>' :
            (single ? '<button type="button" class="amm-btn amm-btn--red" data-amm-wl-add="' + v.id + '">Add to cart</button>' : '<a href="' + p.url + '" class="amm-btn amm-btn--red">Choose options</a>');
          return '<li class="amm-dc-item"><a href="' + p.url + '" class="amm-dc-img">' + (p.featured_image ? '<img src="' + img(p.featured_image, 160) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div class="amm-dc-info"><a href="' + p.url + '" class="amm-dc-title">' + esc(p.title) + '</a>' +
            '<div class="amm-dc-row"><b class="amm-dc-price">' + money(p.price) + (p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</b></div>' +
            '<div class="amm-dc-row">' + btn + '<button type="button" class="amm-dc-remove" data-amm-wl-remove="' + p.handle + '">Remove</button></div></div></li>';
        }).join('') + '</ul>');
      });
  }
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-amm-wish]');
    if (w) { e.preventDefault(); e.stopPropagation(); var a = wlGet(), h = w.dataset.ammWish, i = a.indexOf(h);
      if (i > -1) { a.splice(i, 1); toast('Removed from wishlist'); } else { a.unshift(h); toast('Saved to wishlist ♡'); }
      wlSet(a); return; }
    if (e.target.closest('[data-amm-wishlist-open]')) { e.preventDefault(); openDrawer('AmmWishDrawer'); wlRender(); return; }
    var r = e.target.closest('[data-amm-wl-remove]');
    if (r) { wlSet(wlGet().filter(function (h) { return h !== r.dataset.ammWlRemove; })); wlRender(); return; }
    var ad = e.target.closest('[data-amm-wl-add]');
    if (ad) { ad.disabled = true; ad.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +ad.dataset.ammWlAdd, quantity: 1 }] }) })
        .then(function (res) { if (!res.ok) throw 0; openCart(); }).catch(function () { toast('Could not add to cart', true); ad.disabled = false; ad.textContent = 'Add to cart'; }); }
  });

  /* ---------- Account dropdown: tap support on touch screens ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.amm-acctdrop > .deodap-action-item');
    var open = document.querySelector('.amm-acctdrop.is-open');
    if (t && window.matchMedia('(hover: none)').matches && !t.parentNode.classList.contains('is-open')) { e.preventDefault(); t.parentNode.classList.add('is-open'); return; }
    if (open && !e.target.closest('.amm-acctdrop')) open.classList.remove('is-open');
  });

  /* ---------- Live (predictive) search ---------- */
  function initPSearch(form) {
    if (form.dataset.ammReady) return; form.dataset.ammReady = '1';
    var input = form.querySelector('input[name="q"]'); if (!input) return;
    form.classList.add('amm-ps-host');
    var box = document.createElement('div'); box.className = 'amm-ps'; box.hidden = true; box.setAttribute('role', 'listbox');
    form.appendChild(box);
    var trending = (form.dataset.trending || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var timer, ctrl, searchVersion = 0;
    function showTrending() {
      searchVersion++; if (ctrl) ctrl.abort();
      if (!trending.length) { box.hidden = true; return; }
      box.innerHTML = '<p class="amm-ps__h">Trending searches</p><div class="amm-ps__chips">' + trending.map(function (t) { return '<a href="/search?q=' + encodeURIComponent(t) + '&type=product">' + esc(t) + '</a>'; }).join('') + '</div>';
      box.hidden = false;
    }
    function search(q) {
      var version = ++searchVersion;
      if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); }).then(function (d) {
          if (version !== searchVersion || input.value.trim() !== q) return;
          var R = (d.resources && d.resources.results) || {}, ps = R.products || [], cs = R.collections || [];
          var html = '';
          if (cs.length) html += '<p class="amm-ps__h">Categories</p><div class="amm-ps__chips">' + cs.slice(0, 4).map(function (c) { return '<a href="' + c.url + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
          if (ps.length) html += '<p class="amm-ps__h">Products</p><ul class="amm-ps__list">' + ps.map(function (p) {
            return '<li><a href="' + p.url + '">' + (p.image ? '<img src="' + img(p.image, 100) + '" alt="" loading="lazy">' : '<span class="amm-ps__noimg"></span>') + '<span><b>' + esc(p.title) + '</b><em>' + (p.price ? '₹' + p.price.replace(/\.00$/, '') : '') + '</em></span></a></li>';
          }).join('') + '</ul>';
          html += ps.length || cs.length ? '<a class="amm-ps__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results for “' + esc(q) + '”</a>' : '<p class="amm-ps__none">No matches for “' + esc(q) + '”. Try another word.</p>';
          box.innerHTML = html; box.hidden = false;
        }).catch(function () {});
    }
    input.addEventListener('focus', function () { if (!input.value.trim()) showTrending(); else search(input.value.trim()); });
    input.addEventListener('input', function () { clearTimeout(timer); var q = input.value.trim(); timer = setTimeout(function () { q.length > 1 ? search(q) : showTrending(); }, 220); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { box.hidden = true; input.blur(); } });
  }


  /* ---------- Login / signup popup (deodap-style) ---------- */
  function openLogin(tab) {
    var m = document.getElementById('AmmLoginModal'); if (!m) return false;
    closeDrawers(true); lastFocus = document.activeElement;
    m.hidden = false; m.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { m.classList.add('is-open'); });
    document.documentElement.classList.add('amm-lock');
    switchTab(tab || 'login');
    try { localStorage.setItem('amm_login_seen', Date.now()); } catch (e) {}
    return true;
  }
  function closeLogin() {
    var m = document.getElementById('AmmLoginModal'); if (!m || m.hidden) return;
    m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true');
    setTimeout(function () { m.hidden = true; }, 200);
    document.documentElement.classList.remove('amm-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function switchTab(t) {
    var m = document.getElementById('AmmLoginModal'); if (!m) return;
    m.querySelectorAll('[data-amm-mtab]').forEach(function (b) { var on = b.dataset.ammMtab === t; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
    m.querySelectorAll('[data-amm-mpanel]').forEach(function (p) { p.hidden = p.dataset.ammMpanel !== t; });
    var f = m.querySelector('[data-amm-mpanel="' + t + '"] input'); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  document.addEventListener('click', function (e) {
    var acct = e.target.closest('.amm-acctdrop > .deodap-action-item, .amm-acctdrop__login, .deodap-mobile-header a[title="Account"], .amm-bottomnav a[href*="/account"]');
    if (acct && document.getElementById('AmmLoginModal')) {
      if (acct.classList.contains('deodap-action-item') && window.matchMedia('(hover: none)').matches && !acct.parentNode.classList.contains('is-open')) return;
      e.preventDefault(); openLogin('login'); return;
    }
    var t = e.target.closest('[data-amm-mtab]'); if (t) { switchTab(t.dataset.ammMtab); return; }
    if (e.target.closest('[data-amm-modal-close]') || e.target.id === 'AmmLoginModal') closeLogin();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLogin(); });
  (function perks() {
    var wrap = document.querySelector('[data-amm-perks]'); if (!wrap || reduceMotion) return;
    var items = wrap.children, dots = document.querySelectorAll('.amm-modal__dots i'), i = 0;
    setInterval(function () { items[i].classList.remove('is-on'); dots[i] && dots[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); dots[i] && dots[i].classList.add('is-on'); }, 3000);
  })();
  /* Auto-show once a week for new visitors, after 12 seconds */
  setTimeout(function () {
    var m = document.getElementById('AmmLoginModal'); if (!m || m.dataset.autoShow !== 'true' || (window.Shopify && Shopify.designMode) || document.querySelector('.amm-drawer.is-open')) return;
    if (/\/(account|checkout|cart)/.test(location.pathname)) return;
    var seen = 0; try { seen = +localStorage.getItem('amm_login_seen') || 0; } catch (e) {}
    if (Date.now() - seen > 7 * 864e5) openLogin('register');
  }, 12000);

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-amm-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-amm-scroller-wrap]').forEach(initScrollerWrap);
    (scope || document).querySelectorAll('[data-amm-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-amm-pdp]').forEach(initPDP);
    (scope || document).querySelectorAll('[data-amm-related]').forEach(initRelated);
    (scope || document).querySelectorAll('[data-amm-psearch]').forEach(initPSearch);
    wlSync();
    if (document.querySelector('[data-amm-wl-page]')) wlRender();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  /* Re-init inside the theme editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
